var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 12,
    viewBox: "0 0 24 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.51002 0.0792211C1.707 0.078957 1.90209 0.117702 2.08402 0.193221C2.26595 0.26874 2.43113 0.379538 2.57002 0.519221L10.243 8.19122C10.4752 8.42344 10.7508 8.60765 11.0542 8.73332C11.3575 8.859 11.6827 8.92369 12.011 8.92369C12.3394 8.92369 12.6645 8.859 12.9679 8.73332C13.2712 8.60765 13.5469 8.42344 13.779 8.19122L21.44 0.529221C21.5784 0.385956 21.7439 0.271682 21.9269 0.193069C22.1099 0.114455 22.3067 0.0730764 22.5059 0.0713457C22.7051 0.069615 22.9026 0.107567 23.087 0.182989C23.2713 0.25841 23.4388 0.36979 23.5796 0.510629C23.7204 0.651468 23.8318 0.818946 23.9073 1.00329C23.9827 1.18763 24.0206 1.38515 24.0189 1.58432C24.0172 1.78349 23.9758 1.98032 23.8972 2.16333C23.8186 2.34633 23.7043 2.51185 23.561 2.65022L15.9 10.3122C14.8679 11.3424 13.4693 11.921 12.011 11.921C10.5528 11.921 9.15411 11.3424 8.12202 10.3122L0.449019 2.64022C0.239103 2.43044 0.0961325 2.1631 0.0381983 1.87204C-0.0197358 1.58098 0.00997037 1.27928 0.123558 1.0051C0.237145 0.730931 0.429509 0.496613 0.676308 0.3318C0.923106 0.166987 1.21325 0.0790866 1.51002 0.0792211Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.e0be914ad1454b19629873ed613f38d5.svg";
export { ForwardRef as ReactComponent };